import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { Bed, Building, Trash2 } from "lucide-react";

import { useFormik } from 'formik';
import * as Yup from 'yup';
import Lottie from 'lottie-react';
import { toast } from 'react-toastify';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';
import animPage from 'assets/anim/anim-pageload.json';

import ServiceMain from 'services/serviceMain';
import moment from 'moment/moment';

export default function PaneHostel(props) {

    const [floors, setFloors] = useState([]);
    const [filterFloor, setFilterFloor] = useState([]);
    const [types, setTypes] = useState([]);

    const [selUnit, setSelUnit] = useState({});
    const [aflor, setAFloor] = useState({});


    const [selFloor, setSelFloor] = useState('all');
    const [selID, setID] = useState('');

    const [selIndex, setIndex] = useState(-1);

    const [isOpenAdd, setIsOpenAdd] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(true);

    const mainService = new ServiceMain();

    const formVSchema = Yup.object().shape({
        title: Yup.string().required('This information is required'),
        price: Yup.number().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm } = useFormik({
        initialValues: {
            title: '',
            price: ''
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            setSubmit(true);
            let newSubUnit = {
                "title": values.title,
                "price": values.price,
                "type": "BED",
                "custID": "",
                "total": 0.00,
                "paid": 0.00,
                "pending": 0.00,
                "status": "none",
                "startTime": new Date().toISOString(),
                "endTime": new Date().toISOString(),
            }

            let units = [...aflor.units];
            let tempUnit = selUnit;
            if (tempUnit.subunit === undefined) {
                tempUnit.subunit = [];
            }
            tempUnit.subunit.push(newSubUnit);
            units[selIndex] = tempUnit;

            let body = {
                "path": "floor/updateFloor",
                "body": {
                    fid: selID,
                    data: {
                        units: units
                    }
                }
            };
            mainService.getMain(body, props.outlet.orgid).then((res) => {
                setSubmit(false);
                if (res.status) {
                    resetForm();
                    setIsOpenAdd(false);
                    loadData();
                    toast.success("Bed updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                } else {
                    toast.error("Server error, please try again!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        }
    });

    const deleteUnit = (index) => {
        if (selUnit.subunit[index].status === 'none') {
            let units = [...aflor.units];
            let tempUnit = selUnit;
            tempUnit.subunit.splice(index, 1);
            units[selIndex] = tempUnit;
            let body = {
                "path": "floor/updateFloor",
                "body": {
                    fid: selID,
                    data: {
                        units: units
                    }
                }
            };
            mainService.getMain(body, props.outlet.orgid).then((res) => {
                setSubmit(false);
                if (res.status) {
                    loadData();
                    toast.success("Room updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                } else {
                    toast.error("Server error, please try again!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        } else {
            toast.error('Please clear all the bills for the bed.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        }
    }

    const openBed = (floor, unit, id, index) => {
        setAFloor(floor);
        setSelUnit(unit);
        setID(id);
        setIndex(index);
        setIsOpen(true);
    }

    const closeBed = () => {
        setIsOpen(false);
        setAFloor({});
        setSelUnit({});
        setID('');
        setIndex(-1);
    }

    const getColor = (sts) => {
        switch (sts) {
            case 'active':
                return 'bg-green-200';
            case 'inprog':
                return 'bg-red-200';
            case 'none':
            default:
                return 'bg-white';
        }
    }

    const getActive = (subunits) => {
        if (subunits === undefined) return 0;
        return subunits.filter((a) => a.status !== "none").length;
    }

    const getUnits = (units) => {
        return units.filter((item) => item.type === 'Room');
    }

    const getRoomType = (id) => {
        const items = types.filter((type) => type._id === id);
        if (items.length !== 0) {
            return items[0]['name'];
        }
        return "NA";
    }

    const sortTable = (filter) => {
        setSelFloor(filter);
        if (filter === 'all') {
            setFilterFloor(floors);
        } else {
            let tempList = floors.filter((item) => item.title === filter);
            setFilterFloor(tempList);
        }
    }

    const loadData = () => {
        setLoading(true);
        (async function () {
            let bodyRT = {
                "path": "roomType/getAllRoomType",
                "body": {}
            };
            var res = await mainService.getMain(bodyRT, props.outlet.orgid);
            setTypes(res.data);

            let body = {
                "path": "floor/getAllFloor",
                "body": {}
            };
            var res = await mainService.getMain(body, props.outlet.orgid);
            setFloors(res.data);
            setFilterFloor(res.data);
            setSelFloor('all');
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {
                isOpenAdd && <div className='overflow-y-auto overflow-x-hidden z-[200] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className="relative w-full max-w-2xl h-full md:h-auto mx-auto bg-white shadow-lg rounded-md mt-10 p-4">
                        <div className='flex items-center justify-between'>
                            <h3 className="text-xl font-semibold text-gray-900">
                                Add Bed &nbsp;
                            </h3>
                            <span className='bg-gray-200 hover:bg-gray-100 w-8 h-8 rounded-full cursor-pointer flex items-center justify-center' onClick={() => {
                                setIsOpenAdd(false);
                                resetForm();
                            }}>
                                <i className="las la-times text-sm text-black"></i>
                            </span>
                        </div>
                        <hr className='mt-2' />
                        <form className='mt-4' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                            <div className="mb-6">
                                <label className="block mb-2 text-sm font-medium text-gray-600">Bed Name<sup className="text-red-600">*</sup></label>
                                <input type="text" id="title" value={values.title} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" onChange={handleChange} />
                                {(errors.title && touched.title) && <p className='text-xs text-red-400 mt-1'>{errors.title}</p>}
                            </div>
                            <div className="mb-6">
                                <label className="block mb-2 text-sm font-medium text-gray-600">Bed Price<sup className="text-red-600">*</sup></label>
                                <input type="number" id="price" value={values.price} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" onChange={handleChange} />
                                {(errors.price && touched.price) && <p className='text-xs text-red-400 mt-1'>{errors.price}</p>}
                            </div>
                            <div className='flex items-end justify-end'>
                                <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                    {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                    {!submit && "ADD"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            }
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>{selUnit.title}</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        closeBed();
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='w-full my-4 border border-gray-200 border-dashed p-1 rounded'>
                                    <div className='w-full'>
                                        <div className='flex items-center justify-between'>
                                            <div className='flex items-center'>
                                                <Bed size={22} />
                                                <h1 className='text-xl font-medium uppercase ml-1'>BEDS</h1>
                                            </div>
                                            <div className='w-[28px] h-[28px] bg-prime flex items-center justify-center text-2xl font-medium rounded text-white cursor-pointer hover:bg-primeLight' onClick={() => { setIsOpenAdd(true); }}>+</div>
                                        </div>
                                        <div className='my-2 h-[1px] bg-gray-300'></div>
                                    </div>
                                    <div className='w-full grid grid-cols-6 p-2'>
                                        {
                                            selUnit.subunit === undefined && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                            </div>
                                        }
                                        {
                                            selUnit.subunit !== undefined && selUnit.subunit.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                            </div>
                                        }
                                        {
                                            selUnit.subunit !== undefined && selUnit.subunit.length !== 0 && <div className="rounded col-span-6 cursor-pointer">
                                                <div className='grid grid-cols-7'>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Name</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Price</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Start Date</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>End Date</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Customer</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Status</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>-</p>
                                                    </div>
                                                    <div className='col-span-7 bg-gray-200 h-[1px] my-1'></div>
                                                    {
                                                        selUnit.subunit.map((bed, index) => {
                                                            return <div className={`h-[40px] col-span-7 grid grid-cols-7 p-1 rounded mb-1 ${getColor(bed.status)}`} key={index}>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <Bed size={20} className='cursor-pointer' />
                                                                    <p className='text-base font-serif ml-2'>{bed.title}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-serif'>₹ {bed.price.toFixed(2)}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-serif'>{moment(bed.startTime).format("DD, MMM yy")}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-serif'>{moment(bed.endTime).format("DD, MMM yy")}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-medium font-serif'>-</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-xs font-medium font-serif text-blue-600 bg-blue-100 px-4 py-1 rounded-full uppercase'>{bed.status}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <div className='cursor-pointer text-red-600' onClick={() => { deleteUnit(index); }}>
                                                                        <Trash2 size={18} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            {
                loading && <div className='flex items-center justify-center w-full h-screen'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            {
                !loading && <ScrollArea className="w-full h-full py-2 px-2">
                    <div className="grid grid-cols-12 grid-gap-2">
                        <div className="col-span-12">
                            <div className='w-full min-h-screen bg-gray-100 rounded-md grid grid-cols-12 gap-2 p-2'>
                                <div className='col-span-2 h-full border-r p-2'>
                                    <ul>
                                        <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === 'all' ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} onClick={() => {
                                            sortTable('all');
                                        }}>
                                            All Floors
                                        </li>
                                        {
                                            floors.length !== 0 && floors.map((cunit) => {
                                                return <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === cunit.title ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} key={cunit._id}>
                                                    <div className='flex items-center justify-between'>
                                                        <span className='flex-grow' onClick={() => { sortTable(cunit.title); }}>{cunit.title}</span>
                                                    </div>
                                                </li>
                                            })
                                        }
                                    </ul>
                                </div>
                                <div className='col-span-10'>
                                    {
                                        filterFloor.length !== 0 && filterFloor.map((cuint) => {
                                            return <div className='w-full my-4 border border-gray-200 border-dashed p-1 rounded' key={cuint._id}>
                                                <div className='w-full'>
                                                    <div className='flex items-center justify-between'>
                                                        <div className='flex items-center'>
                                                            <Building size={22} />
                                                            <h1 className='text-xl font-medium uppercase ml-1'>{cuint.title}</h1>
                                                        </div>
                                                    </div>
                                                    <div className='my-2 h-[1px] bg-gray-300'></div>
                                                </div>
                                                <div className='w-full grid grid-cols-6 gap-2'>
                                                    {
                                                        getUnits(cuint.units).length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                            <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                                        </div>
                                                    }
                                                    {
                                                        getUnits(cuint.units).length !== 0 && getUnits(cuint.units).map((unit, index) => {
                                                            return < div className={`h-[130px] p-2 rounded shadow col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md ${getColor(unit.status)}`} key={index} onClick={() => { openBed(cuint, unit, cuint._id, index) }}>
                                                                <div className='flex justify-between items-center px-1'>
                                                                    <div>
                                                                        <p className='text-xl font-medium font-serif'>{unit.title}</p>
                                                                        <p className='text-xs font-medium font-serif text-prime'>{getRoomType(unit.roomTypeId)}</p>
                                                                        <p className='text-base font-medium font-serif mt-1'>₹ {unit.pending.toFixed(2)}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='bg-gray-200 h-[1px] my-2'></div>
                                                                <div className='flex items-center justify-between'>
                                                                    <div className='text-gray-400 flex items-center'>{getActive(unit.subunit)}/{unit.subunit !== undefined ? unit.subunit.length : 0} Beds Active</div>
                                                                    <Bed size={18} className='cursor-pointer' />
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </ScrollArea >
            }
        </>
    )
}
